import { AdsContext } from "@magalu/ecomm-components/contexts/AdsContext";
import { WishlistContext } from "@magalu/ecomm-components/contexts/WishlistContext";
import cookieParser from "@magalu/ecomm-components/rave/utils/cookieParser";
import userTrack from "@magalu/ecomm-components/rave/utils/userTrack";
import useClientEnv from "@magalu/rave/config/useClientEnv";
import { ErrorBoundary } from "@magalu/rave/errorBoundary";
import { useCookies } from "@magalu/rave/router";
import { whereami } from "@magalu/rave/utils";
import { PlatformHooksProvider } from "@magalu/ravejs-platform-hooks";
import { useRouter } from "next/compat/router";
import React, { useEffect } from "react";
import { PAGE_BEFORE_LOGIN } from "./constants/cookies";
import DatadogInit from "./modules/DatadogInit/DatadogInit";
export const render = ({ Component, pageProps }) => {
    const { client } = useClientEnv();
    const cookie = useCookies(undefined, cookieParser);
    const router = useRouter();
    const handleRedirectErrorBoundary = () => {
        router.replace("/500/");
        return null;
    };
    useEffect(() => {
        if (whereami.isClientSide) {
            userTrack.generateTrackId(client.cookieDomain);
        }
    }, []);
    useEffect(() => {
        var _a, _b, _c;
        const isUserNotLogged = ((_a = pageProps === null || pageProps === void 0 ? void 0 : pageProps.data) === null || _a === void 0 ? void 0 : _a.userInfo) && !((_c = (_b = pageProps === null || pageProps === void 0 ? void 0 : pageProps.data) === null || _b === void 0 ? void 0 : _b.userInfo) === null || _c === void 0 ? void 0 : _c.isLogged);
        if (isUserNotLogged) {
            cookie.setCookie(PAGE_BEFORE_LOGIN, pageProps.route.name, {
                domain: client === null || client === void 0 ? void 0 : client.cookieDomain,
                path: "/",
            });
        }
    }, [pageProps === null || pageProps === void 0 ? void 0 : pageProps.route]);
    const accountData = cookie.getCookie("ml2_sid_c");
    return (<PlatformHooksProvider config={pageProps === null || pageProps === void 0 ? void 0 : pageProps.manifest}>
      <ErrorBoundary onRenderWithError={handleRedirectErrorBoundary}>
        <WishlistContext values={{
            isLogged: Boolean(accountData),
            useUnloggedWishlist: true,
            userId: cookie.getCookie("stwu"),
        }}>
          <DatadogInit />
          <AdsContext data={pageProps.data}>
            <Component {...pageProps}/>
          </AdsContext>
        </WishlistContext>
      </ErrorBoundary>
    </PlatformHooksProvider>);
};
